// A lead's conversation: every email both ways, from Ops and from Gmail, oldest
// first (backend services/growth/conversation.ts).

import { apiFetch } from './client'
import type { ISODateTime } from './types'

export interface ConversationMessage {
  key: string
  /** campaign and one_off: sent from Ops. gmail: the copy the inbox reader kept. snippet: an early reply, only its first words. */
  source: 'campaign' | 'one_off' | 'gmail' | 'snippet'
  /** out: from us. in: from them. */
  direction: 'out' | 'in'
  status: 'sent' | 'dry_run' | 'failed' | 'scheduled' | 'received'
  at: ISODateTime
  from: string
  to: string
  subject: string | null
  /** Plain text, unsubscribe links hidden. A stranger's words: show as text. */
  text: string
  /** What a reply in the thread answers; null when there's no real message (a dry run, a snippet). */
  message_id: string | null
  campaign: { id: number; name: string; step_number: number } | null
  signer_name: string | null
  replied: boolean
  bounced: boolean
  unsubscribed: boolean
  /** Written in Gmail directly, not in Ops. */
  from_gmail: boolean
}

export interface LeadConversation {
  email: string | null
  messages: ConversationMessage[]
  /** Whether Gmail is read on this server, when last, and what went wrong. */
  mailbox: { configured: boolean; polled_at: ISODateTime | null; error: string | null }
}

export function leadConversation(leadId: number, signal?: AbortSignal): Promise<LeadConversation> {
  return apiFetch(`/admin/platform/growth/leads/${leadId}/conversation`, { signal })
}

/** Refresh: read this address's mail from Gmail now (Inbox and Sent). 409 not_a_contact, 503 mailbox_unavailable. */
export function syncConversation(email: string): Promise<{ added: number; mailbox_configured: boolean }> {
  return apiFetch('/admin/platform/growth/conversations/sync', { method: 'POST', body: { email } })
}

/** An inquiry's: the same, by their address. */
export function inquiryConversation(inquiryId: number, signal?: AbortSignal): Promise<LeadConversation> {
  return apiFetch(`/admin/platform/growth/inquiries/${inquiryId}/conversation`, { signal })
}
